import { Component } from '@angular/core';
import { WordpressService } from '../../../services/http/wordpress/wordpress.service';
import { WpClientCode, WpSectionCode } from '../../../services/http/wordpress/wordpress.interface';
import { ImageSectionHeadComponent } from '../../../components/image-section-head/image-section-head.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-data-protection',
  standalone: true,
  imports: [CommonModule, ImageSectionHeadComponent],
  templateUrl: './data-protection.component.html',
  styleUrl: './data-protection.component.scss'
})
export class DataProtectionComponent {
  dataProtectionText = '';
  title = "";
  description = "";
  image = "";

  constructor(
    private readonly wordpressService: WordpressService
  ) {
    this.wordpressService.getPost({section: WpSectionCode.dataProtection, client: WpClientCode.genCat}).subscribe((response) => {
      this.dataProtectionText = response?.content.rendered || '';
      this.title = response?.title.rendered || '';
      this.image = response?.acf.image_url || '';
    });
  }
}
